import { useContext, useLayoutEffect, useMemo, useState } from "react";
import CustomizerContext from "../../../../../_helper/Customizer";
import {
  Description,
  IncomeCategory,
  IncomeGroup,
  Name,
  Status,
  CreatedBy,
  ModifiedBy,
} from "../../../../../Constant";
import useAuth from "../../../../../Hooks/useAuth";
import { financesIncomeCategoryApi, financesIncomeGroupApi } from "../../../../../api";
import { createDropdownField } from "../../../../../Data/FormField/PublicData";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";
import { IIncomeGroupResponse } from "../IIncomeGroup.types";
import { StatusRow } from "../../ReportType/List/ReportTypeList";
import { formatDateWithTimeZone } from "../../../../../_helper/dateHelper";
import { toast } from "react-toastify";

export default function useIncomeGroupListController() {
  const axiosPrivate = useAxiosPrivate();
  const title = IncomeGroup;
  const { userOrganisationId }: any = useAuth();
  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "name",
      name: "name",
      label: Name,
      type: "text",
      value: "",
      required: true,
      colSize: 6,
    },

    {
      id: "description",
      name: "description",
      label: Description,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    },
    {
      id: "is_active",
      name: "is_active",
      label: Status,
      type: "switch",
      value: "1",
      colSize: 6,
    },
  ]);

  //?? DROPDOWNS INITS >
  const incomeCategoryDropDown = createDropdownField(
    axiosPrivate,
    "income_category",
    "income_category",
    IncomeCategory,
    `${financesIncomeCategoryApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}`,
    "",
    6
  );
  incomeCategoryDropDown.onChange = async (id, updatedFields) => {
    const updatedFormFields = updatedFields.map((field: any) => {
      if (field.id === "income_category") {
        return { ...field, value: id };
      }
      return field;
    });
    setFormFields([...updatedFormFields]);
  };
  const handleEdit = (row: (typeof data)[0] | any) => {
    setViewModalOpen(true);
    setEditMode(true);
    incomeCategoryDropDown.onChange(row?.income_category.id, formFields);
    setSelectedRowData(row);
  };

  useLayoutEffect(() => {
    //?? Updates all fields once component is mounted
    (async function () {
      const updatedFields = [incomeCategoryDropDown, ...formFields];
      await incomeCategoryDropDown.fetchOptions();
      setFormFields(updatedFields);
    })();
  }, []);

  const tableColumns = [
    {
      name: Name,
      selector: (row: (typeof data)[0]) => `${row.name}`,
      sortable: true,
      center: false,
    },
    {
      name: IncomeCategory,
      selector: (row: (typeof data)[0]) => `${row.income_category.name}`,
      sortable: true,
      center: false,
    },
    {
      name: Status,
      selector: (row: (typeof data)[0]) => `${row.is_active}`,
      sortable: true,
      center: true,
      cell: (row: (typeof data)[0]) => StatusRow(row),
    },
    {
      name: CreatedBy,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.created_at)}`,
      sortable: false,
      center: false,
    },

    {
      name: ModifiedBy,
      selector: (row: (typeof data)[0]) =>
        `${formatDateWithTimeZone(row.updated_at)}`,
      sortable: false,
      center: false,
    },
  ];

  const { layoutURL } = useContext(CustomizerContext);
  const newBtn = `${process.env.PUBLIC_URL}/finance/settings/income-group/create/${layoutURL}`;
  // const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<IIncomeGroupResponse[]>([]);

  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<
    (typeof data)[0] | null
  >(null);

  const [editMode, setEditMode] = useState(false);

  const handleView = (row: (typeof data)[0]) => {
    setViewModalOpen(true);
    setEditMode(false);
    setSelectedRowData(row);
  };

  const fetchData = () => {
    setLoading(true);
    axiosPrivate
      .get(
        `${financesIncomeGroupApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}`
      )
      .then((res) => {
        const response: IIncomeGroupResponse[] = res.data;
        setData(response);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          toast.error(err.response.data.detail);
        } else {
          toast.error('Something Went Wrong');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [loading, setLoading] = useState(true);
  useLayoutEffect(() => {
    fetchData();
  }, []);

  const handleEditRec = async (
    id: number | string,
    editRecord: (typeof data)[0]
  ) => {
    //??dynmically send the selected income_type_id to the server
    let income_category_id = Number(editRecord.income_category);
    editRecord.income_category_id = income_category_id;

    await axiosPrivate
      .put(`${financesIncomeGroupApi}/${id}`, editRecord)
      .then((_res) => {
        const updatedData = data.map((row) =>
          row.id === selectedRowData!.id ? { ...row, ..._res.data } : row
        );
        setData(updatedData);
        toast.success(`${_res.data.name} Editted Successfully.`)
        //fetchData();
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error('Validation Errors');
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error('Something Went Wrong');
        }
        throw err;
        //toast.error(err.response.message || "Whoops! Something went wrong");
      });
    //console.log(editRecord);
  };

  const memoizedHandleEdit = useMemo(
    () => handleEditRec,
    [data, selectedRowData]
  );

  return {
    data,
    tableColumns,
    viewModalOpen,
    selectedRowData,
    editMode,
    newBtn,
    title,
    formFields,
    setViewModalOpen,
    handleView,
    handleEdit,
    memoizedHandleEdit,
    loading,
  };
}
